export default {
  login: 'Login',
  systemLogin: 'System Login',
  oldPassword: 'Old Password',
  newPassword: 'New Password',
  password: 'Password',
  username: 'Username',
  phoneNumber: 'Phone Number',
  verificationCode: 'Verification Code',
  getVerificationCode: 'Verification',
  reacquire: 'Reacquire({{time}})',
  phoneNumberError: 'Please enter a valid 11-digit phone number',
  rememberMe: 'Remember Me',
  resetPassword: 'Reset Password',
  verificationPassed: 'Verification Passed',
  forgetPassword: 'Forget Password?',
  confirmPassword: 'Confirm Password',
  confirmPasswordMessage: 'Password and confirmation password are not the same!',
  notPermissions: 'The user has no permission to log in',
  passwordRuleMessage: 'The password is 6-30 characters and must contain letters and numbers!',
};
